import { CircularPercentage, HStack, Icon, Shadow, Stack, Text } from '@genial/components';
import { BoxBorder } from '@genial/design-tokens';
import { Box, VStack } from 'native-base';
import React, { useState } from 'react';
import { Pressable } from 'react-native';

import { ProfitabilityWithIcon } from '../../../../../../../../components/ProfitabilityWithIcon';
import { RecommendedPortfolioAssetsItem } from '../../../../../../../../store/customerAssetDetail/types';
import { PortfolioAssets } from '../PortfolioAssets';

export interface PortfolioCardProps {
  portfolio: RecommendedPortfolioAssetsItem;
  isMobile?: boolean;
  isTablet?: boolean;
}

export const PortfolioCard: React.FC<PortfolioCardProps> = ({ portfolio, isMobile, isTablet }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const chevronIcon = isExpanded ? 'ChevronUp' : 'ChevronDown';

  const handleDetailsClick = () => {
    setIsExpanded(!isExpanded);
  };

  if (isMobile) {
    return (
      <>
        <Shadow level={1} borderRadius={BoxBorder.heavy}>
          <HStack
            position="relative"
            borderRadius="8px"
            alignItems="center"
            justifyContent="space-between"
            padding="inset.xs">
            <Box
              position="absolute"
              top={0}
              left={0}
              bottom={0}
              w="4px"
              backgroundColor="product.rendavariavel"
              borderTopLeftRadius="full"
              borderBottomLeftRadius="full"
            />
            <HStack alignItems="center" space="inline.xxs">
              <CircularPercentage
                loading={false}
                data={[{ color: 'product.rendavariavel', percentage: portfolio.percentage || 0 }]}
                size={60}
                textProps={{
                  color: 'neutral.black',
                  fontFamily: 'fontfamily.base.regular',
                  fontSize: 'fontsize.xs',
                }}
              />

              <VStack space="stack.nano">
                <Text variant="semibold" fontSize="lg" color="neutral.darkest">
                  {portfolio.assetNameNormalized}
                </Text>

                <HStack space="stack.nano" alignItems="flex-end">
                  <Text variant="semibold" fontSize="xs" color="neutral.medium">
                    TOTAL
                  </Text>
                  <Text variant="semibold" color="neutral.darkest">
                    {portfolio.appliedValueNormalized}
                  </Text>
                </HStack>
                <ProfitabilityWithIcon
                  profitability={portfolio.profitabilityNormalized}
                  textProps={{ variant: 'semibold' }}
                />
              </VStack>
            </HStack>

            <Stack>
              <Pressable onPress={handleDetailsClick}>
                <Icon name={chevronIcon} size="xs" color="brand.primary.principal" />
              </Pressable>
            </Stack>
          </HStack>
        </Shadow>
        {isExpanded && (
          <Stack p="inset.nano">
            <PortfolioAssets assets={portfolio.assetsNormalized} />
          </Stack>
        )}
      </>
    );
  }

  return (
    <>
      <Shadow level={1} borderRadius={BoxBorder.heavy}>
        <HStack
          position="relative"
          borderRadius="8px"
          alignItems="center"
          justifyContent="space-between"
          padding="inset.xs">
          <Box
            position="absolute"
            top={0}
            left={0}
            bottom={0}
            w="4px"
            backgroundColor="product.rendavariavel"
            borderTopLeftRadius="full"
            borderBottomLeftRadius="full"
          />
          <HStack alignItems="center" space="inline.xxs">
            <CircularPercentage
              loading={false}
              data={[{ color: 'product.rendavariavel', percentage: portfolio.percentage || 0 }]}
              size={60}
              textProps={{
                color: 'neutral.black',
                fontFamily: 'fontfamily.base.regular',
                fontSize: 'fontsize.xs',
              }}
            />

            <VStack space="stack.nano">
              <Text variant="semibold" fontSize="lg" color="neutral.darkest">
                {portfolio.assetNameNormalized}
              </Text>

              <ProfitabilityWithIcon
                profitability={portfolio.profitabilityNormalized}
                textProps={{ variant: 'semibold' }}
              />
            </VStack>
          </HStack>

          <HStack space="stack.nano" alignItems="flex-end">
            {!isTablet && (
              <Text variant="semibold" fontSize="xs" color="neutral.medium">
                Valor Aplicado
              </Text>
            )}
            <Text variant="semibold" color="neutral.darkest">
              {portfolio.appliedValueNormalized}
            </Text>
            <Stack>
              <Pressable onPress={handleDetailsClick}>
                <Icon name={chevronIcon} size="xs" color="brand.primary.principal" />
              </Pressable>
            </Stack>
          </HStack>
        </HStack>
      </Shadow>
      {isExpanded && (
        <Stack p="inset.nano">
          <PortfolioAssets assets={portfolio.assetsNormalized} />
        </Stack>
      )}
    </>
  );
};
